// Hero block: initial hidden state is baked into the HTML by render.php.
// This script only adds transitions and triggers the reveal.
document.addEventListener( 'DOMContentLoaded', () => {
	const heroes = Array.from( document.querySelectorAll( '.hero-block' ) );
	if ( ! heroes.length ) return;

	const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
	const DUR    = 0.7;

	heroes.forEach( ( hero ) => {
		const headline    = hero.querySelector( '.hero-headline' );
		const subheadline = hero.querySelector( '.hero-subheadline' );
		const btnWrap     = hero.querySelector( '.hero-btn-wrap' );
		const btn         = hero.querySelector( '.hero-btn' );

		// Add transitions now (not in PHP so they don't run during page load before JS fires)
		const addTransition = ( el, delay ) => {
			if ( ! el ) return;
			el.style.transition = `opacity ${ DUR }s ${ EASING } ${ delay }s, transform ${ DUR }s ${ EASING } ${ delay }s`;
		};

		addTransition( headline,    0.3  );
		addTransition( subheadline, 0.48 );
		addTransition( btnWrap,     0.66 );

		// Small timeout gives the browser one paint cycle to commit initial state + transitions
		setTimeout( () => {
			const reveal = ( el, opacity = '1' ) => {
				if ( ! el ) return;
				el.style.opacity   = opacity;
				el.style.transform = 'translateY(0)';
			};
			reveal( headline );
			reveal( subheadline, '0.85' );
			reveal( btnWrap );
		}, 50 );

		// Button hover — replace transition after the intro completes so it only handles hover
		if ( btn ) {
			const baseColor  = btn.dataset.baseColor;
			const hoverColor = btn.dataset.hoverColor;

			setTimeout( () => {
				btn.style.transition = 'background-color 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease';
			}, ( 50 + ( 0.66 + DUR ) * 1000 ) );

			btn.addEventListener( 'mouseenter', () => {
				btn.style.backgroundColor = hoverColor;
				btn.style.transform       = 'translateY(-2px)';
				btn.style.boxShadow       = '0 8px 24px rgba(0,0,0,0.35)';
			} );
			btn.addEventListener( 'mouseleave', () => {
				btn.style.backgroundColor = baseColor;
				btn.style.transform       = 'translateY(0)';
				btn.style.boxShadow       = '0 4px 16px rgba(0,0,0,0.25)';
			} );
		}
	} );
} );
